import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
export default function Planning() {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [dateStart, setDateStart] = useState(new Date());
  const [dateEnd, setDateEnd] = useState(new Date());
  const [sumProcess, setSumProcess] = useState(0);
  const [checkAll, setCheckAll] = useState(true);

  const SearchDate = (startdate, enddate) => {
    const newData = data.filter((x) => {
      return new Date(x.EtdPol) >= startdate && new Date(x.EtdPol) <= enddate;
    });

    setDataFilter(newData);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <GridToolbarExport
          style={{
            color: "#84BD5A",
            borderColor: "#84BD5A",
            border: "1px solid #84BD5A",
          }}
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fields: [
              "Status",
              "Qty",
              "ShipperRefNo",
              "BookingNo",
              "LinersName",
              "PackaegName",
              "CommodityName",
              "PickupFirst",

              "SpDate",
              "EtdCloseingDate",
              "EtdCloseingTime",

            ],
            fileName: "PlanningData " + new Date() + Math.random(),
          }}
        />
      </GridToolbarContainer>
    );
  }

  /* table data */
  const columns = [
    {
      field: "Status",
      headerName: "STATUS",

      width: 150,
      renderCell: ({ value }) => {
        switch (value) {
          case "1":
            return (
              <Chip
                label="New"
                style={{ color: "white", backgroundColor: "#51D2C5" }}
              />
            );
          case "2":
            return (
              <Chip
                label="Processing"
                style={{ color: "white", backgroundColor: "#DFA003" }}
              />
            );
          case "3":
            return (
              <Chip
                label="AssignToPlanner"
                style={{ color: "white", backgroundColor: "#DFA003" }}
              />
            );
          case "4":
            return (
              <Chip
                label="AssignToCy"
                style={{ color: "white", backgroundColor: "#DFA003" }}
              />
            );

          case "5":
            return (
              <Chip
                label="Confirm"
                style={{ color: "white", backgroundColor: "#DFA003" }}
              />
            );
          case "6":
            return (
              <Chip
                label="AssignToDocument"
                style={{ color: "white", backgroundColor: "#DFA003" }}
              />
            );
          case "7":
            return (
              <Chip
                label="AssignToAdmin"
                style={{ color: "white", backgroundColor: "#DFA003" }}
              />
            );
          case "8":
            return (
              <Chip
                label="Complete"
                style={{ color: "white", backgroundColor: "#28A745" }}
              />
            );
          default:
            return (
              <Chip
                label="unidentified"
                style={{ color: "white", backgroundColor: "#FF202B" }}
              />
            );
        }
      },
      // value == 1 ? (
      //   <Chip
      //     label="Complete"
      //     style={{ color: "white", backgroundColor: "#28A745" }}
      //   />
      // ) : (
      //   <Chip
      //     label="Danger"
      //     style={{ color: "white", backgroundColor: "#FF202B" }}
      //   />
      // ),
    },
    { field: "SaleOrderNo", headerName: "Sale Order No.", width: 180 },
    { field: "Qty", headerName: "VOLUME", width: 100 },
    { field: "ShipperRefNo", headerName: "ShipperRefNo", width: 180 },
    { field: "BookingNo", headerName: "BookingNo", width: 180 },
    { field: "LinersName", headerName: "Liners/Friterm", width: 180 },
    { field: "PackageName", headerName: "Package", width: 180 },
    { field: "CommodityName", headerName: "Commodity", width: 180 },
    {
      field: "PickupFirst",
      headerName: "PICK UP DATE",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : '';
      },
    },
    {
      field: "SpDate", headerName: "STUFFING", width: 180, valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : '';
      },
    },

    {
      field: "EtdCloseingDate",
      headerName: "CLOSINGDATE",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : '';
      },
    },
    { field: "EtdCloseingTime", headerName: "CLOSING TIME", width: 200 },
    {
      field: "EtdPol",
      headerName: "ETD",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ?  moment(value).format("DD-MM-YYYY") : '';
      },
    },
    {
      field: "Action",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/CustomerSupport/EditSaleOrder/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },
  ];
  const getStatus = async () => {
    try {
      const data = await api.get("api/planner/container/countstatus");

      setData1(data.data);
      // CalProcess(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get("api/planner/planning/list");
      console.log(data.data);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const CalProcess = async (data) => {
    let sum = 0;
    let i = 2;
    for (i = 2; i <= 5; i++) {
      if (data?.find((x) => x.Status === i.toString())) {
        sum = sum + data?.find((x) => x.Status === i.toString())?.Total;
      }
      setSumProcess(sum);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();
    getStatus();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 0,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            วางแผน
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Planing
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Planner</Typography>
              <Typography>
                <span>&nbsp;</span> / Planing
              </Typography>
            </Grid>
          </Grid>

          {/* <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Planner</Typography>
            <Typography>
              <span>&nbsp;</span> / Planing
            </Typography>
          </Grid> */}
          <Grid style={{ flexDirection: "row", padding: "25px" }}>
            {/* <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                borderRadius: "8px",
                border: "10px solid #878787",
                borderColor: "#878787",
                backgroundColor: "#878787",
                marginRight: "30px",
              }}
            >
              Cancel
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "5")?.Total}
              </text>
            </Typography> */}
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #66ff33",
                borderRadius: "8px",
                borderColor: "#66ff33",
                backgroundColor: "#66ff33",
                marginRight: "30px",
              }}
            >
              Complete
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "Complete")?.Total}
              </text>
            </Typography>

            {/* <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #FF202B",
                borderRadius: "8px",
                borderColor: "#FF202B",
                backgroundColor: "#FF202B",
                marginRight: "30px",
              }}
            >
              Danger
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "2")?.Total}
              </text>
            </Typography> */}
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #ffc000",
                borderRadius: "8px",
                borderColor: "#ffc000",
                backgroundColor: "#ffc000",
                marginRight: "30px",
              }}
            >
              Process
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {
                  data1?.find((x) => x.Status === "Process")?.Total
                  // sumProcess
                }
              </text>
            </Typography>
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #00b0f0",
                borderColor: "#00b0f0",
                borderRadius: "8px",
                backgroundColor: "#00b0f0",
                marginRight: "30px",
              }}
            >
              New
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "New")?.Total}
              </text>
            </Typography>
          </Grid>
          <Grid
            style={{ marginTop: "10px", display: "flex", flexDirection: "row", justifyContent: 'end' }}
            spacing={1}
          >
            <div style={{ display: "flex" }}>
              <DesktopDatePicker
                label="dateStart"
                inputFormat="yyyy/MM/dd"
                value={dateStart}
                minDate={new Date("2017-01-01")}
                onChange={async (newValue) => {
                  setDateStart(newValue);
                  setCheckAll(false);
                  await SearchDate(newValue, dateEnd);
                }}
                renderInput={(params) => (
                  <TextField style={{ width: "60%" }} {...params} />
                )}
              />
              <DesktopDatePicker
                label="dateEnd"
                inputFormat="yyyy/MM/dd"
                value={dateEnd}
                minDate={new Date(dateStart)}
                onChange={async (newValue) => {
                  setDateEnd(newValue);
                  setCheckAll(false);
                  await SearchDate(dateStart, newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    style={{ width: "60%", marginLeft: "10px" }}
                    {...params}
                  />
                )}
              />

              <SearchData name={data} onsetData={setDataFilter} />
            </div>
          </Grid>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkAll}
                onClick={() => {
                  setCheckAll(!checkAll);
                  getData();
                }}
              />
            }
            label="ดูข้อมูลทั้งหมด"
          />

          <Box
            sx={{
              height: 630,
              width: "100%",
              marginTop: "10px",
              "& .Active": {
                color: "#28A745",
              },
              "& .Inactive": {
                color: "#F53C56",
              },
            }}
          >
            <DataGrid
              getRowId={(r) => r.SoId}
              rows={dataFilter}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              getCellClassName={(params) => {
                if (params.field === "Status") {
                  return params.value == 1 ? "Active" : "Inactive";
                }
              }}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </Box>
        </Card>
      </LocalizationProvider>
    </div>
  );
}
